import { UnitConversion } from '../inputs/UnitConversion';

function getMinMaxValuePdp(option, min_max, pdp) {
  if (!pdp) return min_max === 'min' ? 0 : null;
  if (pdp.shape === 'round' && option === 'diameter') {
    option = 'length';
  }
  const key = `${min_max}_${option}`;
  return pdp.hasOwnProperty(key) ? pdp[key] : null;
}

function ValidateProductValue(
  option,
  pdp,
  value,
  result,
  unit = null,
  product = null,
  svFamily = null
) {
  const unitSystem = unit === 'in' || unit === 'lb' ? 'imperial' : 'metric';
  const originUnit = unit === 'in' ? 'mm' : unit === 'lb' ? 'kg' : unit;

  const maxValue = getMinMaxValuePdp(option, 'max', pdp);

  const { displayedValue: displayedMaxValue } = UnitConversion(
    maxValue,
    unitSystem,
    originUnit
  );

  const pdpMin = getMinMaxValuePdp(option, 'min', pdp);
  const minValue =
    option === 'width'
      ? Math.max(pdpMin, result?.product_min_width)
      : option === 'length'
        ? Math.max(pdpMin, result?.product_min_length)
        : option === 'diameter'
          ? Math.max(
              pdpMin,
              result?.product_min_width,
              result?.product_min_length
            )
          : pdpMin;

  const { displayedValue: displayedMinValue } = UnitConversion(
    minValue,
    unitSystem,
    originUnit
  );

  let validateValue = true;
  const warnings = [];
  if (typeof value === 'number') {
    if (maxValue !== null && value > maxValue) {
      validateValue = false;
      warnings.push(
        `Maximum is ${Math.round(displayedMaxValue * 10) / 10}${unit ? ' ' + unit : ''}${pdp ? ' from PDP.' : '.'}`
      );
    }
    if (minValue !== null && value < minValue) {
      validateValue = false;
      warnings.push(
        `Minimum is ${Math.round(displayedMinValue * 10) / 10}${unit ? ' ' + unit : ''}${pdp && pdpMin === minValue ? ' from PDP.' : '.'}`
      );
    }

    if (
      option === 'width' &&
      svFamily === 'SV-L' &&
      product?.product_shape === 'rectangular' &&
      typeof product?.length === 'number' &&
      value > product.length
    ) {
      validateValue = false;
      warnings.push('For SV-L, width cannot be greater than length.');
    }
  }
  if (['', null].includes(value)) {
    validateValue = false;
    warnings.push('Input required.');
  }

  const warning = warnings.join(' ');
  return { validateValue, warning };
}

export default ValidateProductValue;
